/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import { useContext } from 'react';
import { AppBar as MuiAppBar, Box, styled, Toolbar, IconButton, Typography, useTheme } from '@mui/material';
import { Menu } from '@mui/icons-material';
import useAuthorized from '../../../hooks/use-authorized.hook';
import { SidebarContext } from '../sidebar/context/sidebar.context';
import ThemeEnum from '../../../configs/theme/enums/theme.enum';
import { DRAWER_WIDTH_EXPANDED, DRAWER_WIDTH_COLLAPSED } from '../sidebar/sidebar';
import { APP_VERSION } from '../../../configs/constants';

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: theme.palette.background.default,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: "cubic-bezier(0.4, 0, 0.2, 1)",
    duration: 400,
  }),
  boxShadow: '0 1px 3px 0 #a6afc357',
}));

const Header = () => {
  const isAuthorised = useAuthorized();
  const sidebar = useContext(SidebarContext);
  const theme = useTheme();
  const isLightMode = theme.palette.mode === ThemeEnum.LIGHT_MODE;
  
  const handleMenuClick = () => {
    sidebar.toggle();
  };
  
  return (
    <AppBar
      sx={{
        marginLeft: sidebar.opened ? DRAWER_WIDTH_EXPANDED : DRAWER_WIDTH_COLLAPSED,
        width: `calc(100% - ${sidebar.opened ? DRAWER_WIDTH_EXPANDED : DRAWER_WIDTH_COLLAPSED}px)`,
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between', minHeight: '54px !important' }}>
        {isAuthorised && (
          <IconButton
            color="inherit"
            aria-label="toggle sidebar"
            onClick={handleMenuClick}
            edge="start"
            sx={{ 
              mr: 2,
              ml: sidebar.opened ? 0 : 0,
              display: 'flex',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              },
            }}
          >
            <Menu sx={{ 
              fontSize: 24,
              color: isLightMode ? '#000000' : 'inherit',
            }} />
          </IconButton>
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, ml: 'auto' }}>
          <Typography
            sx={{
              fontSize: "0.7rem",
              color: theme.palette.mode === ThemeEnum.LIGHT_MODE ? "#666" : "#999",
            }}
          >
            {APP_VERSION}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
